var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.selectedPrintPosition)?_c('div',{staticClass:"product-preview",style:({ '--value': `${_vm.PREVIEW_IMAGE_BOX}px` })},[_c('img',{staticClass:"product-preview__img",style:({ '--value': `${_vm.PREVIEW_IMAGE_BOX}px` }),attrs:{"src":_vm.selectedVariantImageUrl}}),_vm._l((_vm.activePositionShapes),function(shape){return _c('img',{key:shape.id,staticClass:"product-preview__img-shape",style:({
      height: `${shape.height}px`,
      width: `${shape.width}px`,
      top: `${shape.y}px`,
      left: `${shape.x}px`,
      transform: `rotate(${shape.rotation}rad)`,
    }),attrs:{"src":shape.pngFileUrl}})})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }